module.exports = __webpack_public_path__ + "img/goods05.53582177.png";